import React from "react";
import ReactDOM from "react-dom/client";
import { Collection } from "@app/components/pageCollection/Collection";

class CollectionPage extends HTMLElement {
  collectionHandle: string;

  constructor() {
    super();
    this.collectionHandle = this.getAttribute("data-collection-handle") || "";
  }

  connectedCallback() {
    this.initReactify();
    this.attachProductLinkInterceptor();
  }

  initReactify() {
    const root = ReactDOM.createRoot(this);
    root.render(<Collection handle={this.collectionHandle} />);
  }

  // Bulletproof: intercept clicks on /products/ links at document-level with capture phase.
  // This fires BEFORE any React/Reactify onClick handler can stopPropagation or preventDefault.
  // We check that the click target is inside THIS collection-page, then rewrite navigation
  // to include the current collection handle.
  attachProductLinkInterceptor() {
    if (!this.collectionHandle) return;

    const handler = (e: Event) => {
      const mouseEvent = e as MouseEvent;
      // Don't interfere with modifier-clicks (new tab, etc.) or non-left clicks
      if (mouseEvent.button !== 0 || mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey) return;

      // Find the closest <a> with href
      const target = e.target as HTMLElement;
      if (!target?.closest) return;
      const $a = target.closest("a[href]") as HTMLAnchorElement | null;
      if (!$a) return;

      // Only handle clicks happening inside this collection-page (not random links elsewhere)
      if (!this.contains($a)) return;

      const href = $a.getAttribute("href") || "";

      // Only rewrite naked /products/X URLs — leave already-contextualized URLs alone
      const naked = href.match(/^\/products\/([^/?#]+)(.*)?$/);
      if (!naked) return;

      const productHandle = naked[1];
      const trailing = naked[2] || "";
      const newUrl = `/collections/${this.collectionHandle}/products/${productHandle}${trailing}`;

      // Capture phase — stop propagation so React/Reactify never sees this click
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = newUrl;
    };

    document.addEventListener("click", handler, true); // <-- true = capture phase, fires before bubble
  }
}

customElements.define("collection-page", CollectionPage);
